import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { ReportType } from 'types';
import { ColumnSortControl } from './ColumnSortControl';
import { TableColumn } from 'logic/reports/ReportSettings';
import { sortColumn, unsortColumn, setSortDirection } from 'logic/reports/tableColumns';
import { getColumnSortType } from 'logic/reports/reportType';

import './ColumnSortControlList.css';

type OwnProps = {
    reportType: ReportType;
    columns: ReadonlyArray<TableColumn>;
    onChange: (columns: ReadonlyArray<TableColumn>) => void;
};

const RawColumnSortControlList = ({ reportType, columns, handleSortChanged, handleDirectionChanged }: RecomposeProps & OwnProps) => {
    const sortColumns =
        columns
            .filter(c => typeof c.sortIndex === 'number')
            .sort((a, b) => a.sortIndex! - b.sortIndex!);

    const remainingColumns =
        columns
            .filter(c => typeof c.sortIndex !== 'number')
            .filter(c => typeof c.visibleIndex === 'number') // Hide invisible columns
            .filter(c => !!getColumnSortType(reportType, c.name)) // Hide columns that can't be sorted
            .sort((a, b) => a.visibleIndex! - b.visibleIndex!);

    return (
        <div
            className="column-sort-control-list"
        >
            { sortColumns.map((c, i) =>
                <ColumnSortControl
                    key={ `${i}-${c.name}` }
                    reportType={ reportType }
                    sortIndex={ i }
                    selectedColumn={ c.name }
                    ascending={ c.sortAsc !== false }
                    columns={ columns }
                    onColumnChanged={ handleSortChanged }
                    onDirectionChanged={ handleDirectionChanged }
                />
            ) }
            { !!remainingColumns.length &&
                <ColumnSortControl
                    reportType={ reportType }
                    sortIndex={ sortColumns.length }
                    selectedColumn={ null }
                    ascending={ true }
                    columns={ remainingColumns }
                    onColumnChanged={ handleSortChanged }
                    onDirectionChanged={ handleDirectionChanged }
                />
            }
        </div>
    );
};

type RecomposeProps = {
    handleSortChanged: (index: number, columnName: string | null) => void;
    handleDirectionChanged: (index: number, ascending: boolean) => void;
};

export const ColumnSortControlList = compose<RecomposeProps & OwnProps, OwnProps>(
    withHandlers<OwnProps, RecomposeProps>({
        handleSortChanged: ({ columns, onChange }) => (index: number, columnName: string | null) => {
            columns =
                columnName === null
                    ? unsortColumn(columns, index)
                    : sortColumn(columns, columnName, index);

            onChange(columns);
        },
        handleDirectionChanged: ({ columns, onChange }) => (index: number, ascending: boolean) => {
            columns = setSortDirection(columns, index, ascending);
            onChange(columns);
        },
    }),
)(RawColumnSortControlList);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/tableLayout/ColumnSortControlList.tsx